import React, { useState, useEffect, useMemo } from 'react';

import DialogComp from '../../../Core/Dialog/DialogComp';
import { BreadCrumbs, AddButton, EditButton } from '../../../Core/Controls';
import '../../commonStyle.scss';
import GijgoGrid from '../../../Core/Controls/GijgoGrid';
import VorLoggedByModal from './VorLoggedByModal';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'VOR', active: true },
    { name: 'VOR Logged By', active: true }
];

function VORLoggedBy(props) {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedVORLoggedByID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedVORLoggedByID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const base_columns = [
        { key: 'action', name: 'Action', width: '5%' },
        { key: 'vorLoggedByDescription', name: 'Description', sortable: true }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedVORLoggedByID: row ? row.vorLoggedByID : null
        }));
    };

    const ActionButtons = (data, record) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <EditButton onClick={() => handelAddUpdate(record)} />
            </div>
        );
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let actionCol = newColumn.find((item) => item.key === 'action');
        if (actionCol) {
            actionCol.formatter = ActionButtons;
        }
        return newColumn;
    });

    const onRowDataBound = (e, $row, id, record, GridRef) => {
        $row.css('background-color', record.vorLoggedByBackgroundColour || 'white');
        
    };
    const onCellDataBound = (e, $displayEl, id, column, record) => {
        $displayEl.css('color', record.vorLoggedByTextColour || 'black');
    };

    return (
        <div className="screen">
            <BreadCrumbs crumbs={crumbs} />
            <GijgoGrid
                dataConverter={(res) => ({
                    records: res?.data?.list,
                    total: res?.data?.total
                })}
                columns={columns}
                getUrl={'VORLoggedBy/VORLoggedBy_List'}
                isReload={state.isReload}
                btnTitle="Add VOR Logged By"
                onBtnClick={() => handelAddUpdate(null)}
                onRowDataBound={(e, $row, id, record, GridRef) => onRowDataBound(e, $row, id, record, GridRef)}
                onCellDataBound={(e, $displayEl, id, column, record) => onCellDataBound(e, $displayEl, id, column, record)}
            />
            {state.showModal ? (
                <DialogComp
                    maxWidth="sm"
                    overflow="auto"
                    title={state.selectedVORLoggedByID ? 'Update VOR Logged By' : 'Add VOR Logged By'}
                    onClose={() => handleClose(false)}
                >
                    <VorLoggedByModal vORLoggedByID={state.selectedVORLoggedByID} onClose={() => handleClose(true)} />
                </DialogComp>
            ) : null}
        </div>
    );
}
export default VORLoggedBy;
